// extracted by mini-css-extract-plugin
export default {"wrapBackText":"index_wrapBackText__p4UIo","smallText":"index_smallText__7AgNk","radioButtonsWrap":"index_radioButtonsWrap__6HE7l","spaceItemRadio":"index_spaceItemRadio__Be6fb"};